import { usePageCharts } from '~/api/hooks/useCharts'
import {
  useReviewPageState,
  useComparisonState,
  ReviewPageScaffold,
  PageTiles,
} from '~/components/ReviewPage'
import { CONTRIBUTION_VIEWS } from '~/components/ReviewPage/pageDefaults'
import { useContributionView } from '~/state/useContributionView'
import { useContributionModelDefault } from './useContributionModelDefault'
import { ContributionViewToggle } from './ContributionViewToggle'

// Merged Marketing + Driver Contribution (#13/WP-3, mig 0074 unified the registry page). The view
// toggle switches the two decomposition presets (channels = Sales/Media × 'Medium Level 1';
// groups = Sales/Total × 'Driven by Group'); switching re-seeds KPI + Group-by and keeps
// filters/timeframe (useContributionView). Both presets live on model_tracking, so a plain
// toggle never trips the loud fact reset; a genuine cross-fact selection then toggling does.
export function Contribution() {
  const [view, switchView] = useContributionView()
  // SP-2 (mig 0081): groups view shows sales__total__units grouped by Driven by Group; that kpi
  // carries Model=yhat (Fitted, has lever dims) + Model=actual (gauge-only). Structurally enforce
  // Model=Fitted on the groups view whenever no Model filter is set — re-asserts after Reset
  // Settings (unlike the superseded mount-once useStaticFilterDefault approach).
  useContributionModelDefault(view)
  const viewConfig = CONTRIBUTION_VIEWS[view]
  const state = useReviewPageState({
    pageId: 'Contribution',
    factTable: 'model_success_kpi',
    defaultKpi: viewConfig.defaultKpi,
    archetype: 'performance',
    multiTimeframe: false,
    decomp: { groupByDefault: viewConfig.groupByDefault, facet: viewConfig.facet },
  })
  const compare = useComparisonState(state.fromIso, state.toIso)
  const charts = usePageCharts(state.pageId, state.kpi)
  return (
    <ReviewPageScaffold
      title="Contribution"
      state={state}
      compare={compare}
      extraControls={<ContributionViewToggle view={view} onSwitch={switchView} />}
    >
      <PageTiles charts={charts} state={state} compare={compare} pageSlug="contribution" />
    </ReviewPageScaffold>
  )
}
